import { useNavigate } from 'react-router-dom';
import type { AIFollowUp } from '../types/contracts';
import { shortTime } from '../lib/format';
import { TemperatureBadge } from './LeadScore';

export function FollowUpCard({
  item,
  onComplete,
  onReschedule,
}: {
  item: AIFollowUp;
  onComplete?: (id: string) => void;
  onReschedule?: (id: string) => void;
}) {
  const navigate = useNavigate();
  return (
    <div className="rounded-2xl bg-white border border-gray-100 px-5 py-4 flex flex-wrap items-center gap-4">
      <div className="flex-1 min-w-[220px]">
        <div className="flex items-center gap-2">
          <TemperatureBadge temperature={item.temperature} />
          <p className="text-sm font-bold text-gray-900">{item.customer_name} — {item.business}</p>
        </div>
        <div className="mt-2 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-xs text-gray-600">
          <span>السبب: <b className="text-gray-800">{item.reason}</b></span>
          <span>الإجراء المقترح: <b className="text-gray-800">{item.suggested_action}</b></span>
          <span>الاستحقاق: <b className={item.status === 'overdue' ? 'text-rose-600' : 'text-gray-800'}>{shortTime(item.due_at)}</b></span>
          <span>المسؤول: <b className="text-teal-700">{item.owner}</b></span>
        </div>
      </div>
      {item.status !== 'completed' && (
        <div className="flex items-center gap-2">
          {item.conversation_id && (
            <button type="button" onClick={() => navigate(`/intelligence/conversations/${item.conversation_id}`)}
              className="px-3 py-1.5 rounded-lg border border-gray-200 text-[11px] font-bold text-gray-700 hover:bg-gray-50">
              فتح المحادثة
            </button>
          )}
          <button type="button" onClick={() => onComplete?.(item.id)}
            className="px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-[11px] font-bold hover:bg-emerald-700">
            إتمام
          </button>
          <button type="button" onClick={() => onReschedule?.(item.id)}
            className="px-3 py-1.5 rounded-lg border border-gray-200 text-[11px] font-bold text-gray-700 hover:bg-gray-50">
            إعادة جدولة
          </button>
        </div>
      )}
    </div>
  );
}
